import { ControlIcons } from 'owa-control-icons';
import { createDragAsset } from './utils/createDragAsset';
import { default as MailSearchResult, MailSearchResultProps } from './components/MailSearchResult';
import { getPrimaryMailFolders } from 'owa-folders';
import { getSearchFilterOptions, getResultFilterOptions } from './utils/filterAssets';
import { mailItemAssetName, mailItemPivotHeader, assetErrorEmail } from './mailItem.locstring.json';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import type { MailItemPayload } from './schema';
import { AssetAriaLabel, registerAsset } from 'owa-timestream-asset-sdk';
import { registerSearchableAsset } from 'owa-timestream-asset-search';
import compareAssets from './utils/compareAssets';
import getSearchResultHeaders from './utils/getSearchResultHeaders';
import loc from 'owa-localize';
import TxpOrMailItemView from './components/TxpOrMailItemView';
import searchAsset from './utils/searchAsset';
import popoutMailItemFromPayload from './utils/popoutMailItemFromPayload';
import { unsubscribeFromRowNotifications } from './notifications/rowNotificationsStrategy';

// import orchestrators
import './orchestrators/orchestrators';

// ensure the folders are loaded
// NOTE: this should be moved out of module scope at some point and invocation should be deferred until needed
getPrimaryMailFolders();

const MAIL_ITEM_TYPE = 'mailItem';

export const mailItem = registerAsset<MailItemPayload>({
    type: MAIL_ITEM_TYPE,
    iconName: ControlIcons.Mail,
    getToolName: () => loc(mailItemAssetName),
    getErrorMessage: () => loc(assetErrorEmail),
    createEmptyAsset: () => ({
        type: MAIL_ITEM_TYPE,
        payload: {} as MailItemPayload,
    }),
    unsupportedDefaultCommands: [],
    customRenderDueDate: true,
    CanvasView: TxpOrMailItemView,
    onAssetInvoked: popoutMailItemFromPayload,
    getAriaLabel: getMailItemAriaLabelName,
    getTitleString: getMailItemSubject,
    getSearchString: getMailItemSearchString,
    cleanupAssetData: unsubscribeFromRowNotifications,
});

function getMailItemSubject(payload: MailItemPayload) {
    return payload.item?.Subject || loc(noSubject);
}

function getMailItemAriaLabelName(payload: MailItemPayload) {
    return loc(AssetAriaLabel.assetAriaLabel, loc(mailItemAssetName), getMailItemSubject(payload));
}

function getMailItemSearchString(payload: MailItemPayload) {
    return payload.item?.Subject + ' ' + (payload.item?.Preview ?? '');
}

export const mailSearchItem = registerSearchableAsset<MailSearchResultProps, MailItemPayload>({
    type: MAIL_ITEM_TYPE,
    getHeaderLabel: () => loc(mailItemPivotHeader),
    createDragAsset: createDragAsset,
    SearchView: MailSearchResult,
    searchAsset: searchAsset,
    getSearchFilterOptions: getSearchFilterOptions,
    getResultFilterOptions: getResultFilterOptions,
    compareAssets: compareAssets,
    getSearchResultHeaders: getSearchResultHeaders,
});
